module.exports = "ul {\n  list-style: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0;\n  margin: 0;\n}\n\nul li {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 15px 25px;\n  background: transparent;\n  color: #000;\n  font-weight: 500;\n  font-size: 1.2rem;\n  text-align: center;\n  cursor: pointer;\n}\n\nul li.active {\n  background: #fff;\n  color: #b97546;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cold-calls-listing/cold-calls-listing.component.css
// module id = ./src/app/cold-calls-listing/cold-calls-listing.component.css
// module chunks = main